module.exports = __webpack_public_path__ + "static/img/smart_phone.61ece8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prizes/smart_phone.png
// module id = hJbP
// module chunks = 1